import React from "react"
import "./illustrations.css"

const EmptyResultsIllustration = () => {
    return (
        <svg
            className="animated"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 500 500"
            width={"15rem"}
        >
            <g
                className="animable"
                style={{
                    transformOrigin: "250px 228.23px"
                }}
            >
                <path
                    style={{
                        transformOrigin: "250px 382.525px"
                    }}
                    className="animable"
                    d="M0 382.4H500V382.65H0z"
                    fill="#ebebeb"
                />
                <path
                    style={{
                        transformOrigin: "433.34px 398.615px"
                    }}
                    className="animable"
                    d="M416.78 398.49H449.9V398.74H416.78z"
                    fill="#ebebeb"
                />
                <path
                    style={{
                        transformOrigin: "326.875px 401.335px"
                    }}
                    className="animable"
                    d="M322.53 401.21H331.21999999999997V401.46H322.53z"
                    fill="#ebebeb"
                />
                <path
                    style={{
                        transformOrigin: "406.185px 389.335px"
                    }}
                    className="animable"
                    d="M396.59 389.21H415.78V389.46H396.59z"
                    fill="#ebebeb"
                />
                <path
                    style={{
                        transformOrigin: "74.055px 391.015px"
                    }}
                    className="animable"
                    d="M52.46 390.89H95.65V391.14H52.46z"
                    fill="#ebebeb"
                />
                <path
                    style={{
                        transformOrigin: "107.725px 391.015px"
                    }}
                    className="animable"
                    d="M104.56 390.89H110.89V391.14H104.56z"
                    fill="#ebebeb"
                />
                <path
                    style={{
                        transformOrigin: "178.31px 395.235px"
                    }}
                    className="animable"
                    d="M131.47 395.11H225.15V395.36H131.47z"
                    fill="#ebebeb"
                />
                <path
                    d="M237 337.8H43.91a5.71 5.71 0 01-5.7-5.71V60.66a5.71 5.71 0 015.7-5.66H237a5.71 5.71 0 015.71 5.71v271.38a5.71 5.71 0 01-5.71 5.71zM43.91 55.2a5.46 5.46 0 00-5.45 5.46v271.43a5.46 5.46 0 005.45 5.46H237a5.47 5.47 0 005.46-5.46V60.66A5.47 5.47 0 00237 55.2z"
                    style={{
                        transformOrigin: "140.46px 196.4px"
                    }}
                    className="animable"
                    fill="#ebebeb"
                />
                <path
                    d="M453.31 337.8h-193.1a5.72 5.72 0 01-5.71-5.71V60.66a5.72 5.72 0 015.71-5.66h193.1a5.71 5.71 0 015.69 5.66v271.43a5.71 5.71 0 01-5.69 5.71zM260.21 55.2a5.47 5.47 0 00-5.46 5.46v271.43a5.47 5.47 0 005.46 5.46h193.1a5.47 5.47 0 005.46-5.46V60.66a5.47 5.47 0 00-5.46-5.46z"
                    style={{
                        transformOrigin: "356.75px 196.4px"
                    }}
                    className="animable"
                    fill="#ebebeb"
                />
                <path
                    d="M411.48 347.81s-7.68-15 1.1-29.86 11.32-18.32 5.72-21.36-8.16 11.86-8.16 11.86-4.72-10.25-.82-21 6.34-28.2 1-30.07-1 21.79-5.64 29.86c0 0-3.87-9-4.51-17.6s.36-22.37-3.84-25.9-6.9-1.08-2.77 17.93a179 179 0 014.1 34.46s-9.12-24.94-15.24-25.66-6.11 7.35-.87 14.35 15.34 19.56 17 26c0 0-10-18.76-19-13s7.84 17.09 15.35 21.18 12.71 29.78 12.71 29.78z"
                    style={{
                        transformOrigin: "399.121px 295.579px"
                    }}
                    className="animable"
                    fill="#e0e0e0"
                />
                <path
                    d="M405.41 354s7.49-15.14-1.49-29.85-11.57-18.16-6-21.27 8.32 11.75 8.32 11.75 4.58-10.32.54-21-6.71-28.11-1.42-30.05 1.31 21.78 6 29.78c0 0 3.76-9 4.28-17.65s-.66-22.37 3.5-25.95 6.87-1.18 3 17.88a179.67 179.67 0 00-3.64 34.52s8.79-25.06 14.9-25.87 6.21 7.27 1.06 14.34-15.08 19.76-16.65 26.24c0 0 9.76-18.9 18.84-13.27s-7.61 17.19-15.06 21.39-12.32 29.94-12.32 29.94z"
                    style={{
                        transformOrigin: "417.14px 301.646px"
                    }}
                    className="animable"
                    fill="#e6e6e6"
                />
                <path
                    style={{
                        transformOrigin: "409.02px 363.03px"
                    }}
                    className="animable"
                    d="M439.93 343.19L378.11 343.19 383.11 382.87 434.93 382.87 439.93 343.19z"
                    fill="#f0f0f0"
                />
                <path
                    style={{
                        transformOrigin: "273.35px 154.37px"
                    }}
                    className="animable"
                    d="M217.04 92.06H329.65999999999997V216.68H217.04z"
                    fill="#e9e9e9"
                />
                <path
                    style={{
                        transformOrigin: "273.5px 154.5px"
                    }}
                    className="animable"
                    d="M222 97H325V212H222z"
                    fill="#f4f4f4"
                />
                <path
                    style={{
                        transformOrigin: "236.555px 151.51px"
                    }}
                    className="animable"
                    d="M251.11 97L222 206.02 222 147 235.32 97 251.11 97z"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "245.875px 154.5px"
                    }}
                    className="animable"
                    d="M264.12 97L233.42 212 227.63 212 258.33 97 264.12 97z"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "313.845px 170.18px"
                    }}
                    className="animable"
                    d="M325 128.36L325 187.39 318.48 212 302.69 212 325 128.36z"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "273.35px 154.37px"
                    }}
                    className="animable"
                    d="M271.35 92.06H275.35V216.68H271.35z"
                    fill="#e9e9e9"
                />
                <path
                    style={{
                        transformOrigin: "273.25px 119.35px"
                    }}
                    className="animable"
                    d="M219 117.35H327.5V121.35H219z"
                    fill="#e9e9e9"
                />
                <path
                    style={{
                        transformOrigin: "119.35px 154.37px"
                    }}
                    className="animable"
                    d="M63.04 92.06H175.66V216.68H63.04z"
                    fill="#e9e9e9"
                />
                <path
                    style={{
                        transformOrigin: "119.5px 154.5px"
                    }}
                    className="animable"
                    d="M68 97H171V212H68z"
                    fill="#f4f4f4"
                />
                <path
                    style={{
                        transformOrigin: "82.555px 151.51px"
                    }}
                    className="animable"
                    d="M97.11 97L68 206.02 68 147 81.32 97 97.11 97z"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "91.875px 154.5px"
                    }}
                    className="animable"
                    d="M110.12 97L79.42 212 73.63 212 104.33 97 110.12 97z"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "159.845px 170.18px"
                    }}
                    className="animable"
                    d="M171 128.36L171 187.39 164.48 212 148.69 212 171 128.36z"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "119.35px 154.37px"
                    }}
                    className="animable"
                    d="M117.35 92.06H121.35V216.68H117.35z"
                    fill="#e9e9e9"
                />
                <path
                    style={{
                        transformOrigin: "119.25px 119.35px"
                    }}
                    className="animable"
                    d="M65 117.35H173.5V121.35H65z"
                    fill="#e9e9e9"
                />
            </g>
            <g
                className="animable"
                style={{
                    transformOrigin: "250px 416.24px"
                }}
            >
                <ellipse
                    cx={250}
                    cy={416.24}
                    rx={193.89}
                    ry={11.32}
                    style={{
                        transformOrigin: "250px 416.24px"
                    }}
                    className="animable"
                    fill="#f5f5f5"
                />
            </g>
            <g
                className="animable"
                style={{
                    transformOrigin: "315.149px 246.445px"
                }}
            >
                <path
                    d="M381.66 382.87H228.17a6.52 6.52 0 01-6.59-7.16l19.35-248.24a7.87 7.87 0 017.71-7.16h153.48a6.53 6.53 0 016.6 7.16l-19.35 248.24a7.88 7.88 0 01-7.71 7.16z"
                    style={{
                        transformOrigin: "315.149px 251.59px"
                    }}
                    className="animable"
                    fill="#2e353a"
                />
                <path
                    d="M381.66 382.87H228.17a6.52 6.52 0 01-6.59-7.16l19.35-248.24a7.87 7.87 0 017.71-7.16h153.48a6.53 6.53 0 016.6 7.16l-19.35 248.24a7.88 7.88 0 01-7.71 7.16z"
                    style={{
                        transformOrigin: "315.149px 251.59px"
                    }}
                    className="animable"
                    fill="#fff"
                    opacity={0.2}
                />
                <path
                    d="M360.87 136.54h-73.5a2.28 2.28 0 01-2.31-2.5l1.13-14.51a2.76 2.76 0 012.7-2.51h73.5a2.28 2.28 0 012.3 2.51L363.56 134a2.75 2.75 0 01-2.69 2.54z"
                    style={{
                        transformOrigin: "324.876px 126.78px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <path
                    d="M360.87 136.54h-73.5a2.28 2.28 0 01-2.31-2.5l1.13-14.51a2.76 2.76 0 012.7-2.51h73.5a2.28 2.28 0 012.3 2.51L363.56 134a2.75 2.75 0 01-2.69 2.54z"
                    style={{
                        isolation: "isolate",
                        transformOrigin: "324.876px 126.78px"
                    }}
                    className="animable"
                    opacity={0.2}
                />
                <path
                    d="M331 121.53h-11.5l.45-5.76a6.32 6.32 0 016.19-5.75 5.25 5.25 0 015.31 5.75z"
                    style={{
                        transformOrigin: "325.487px 115.775px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <path
                    d="M331 121.53h-11.5l.45-5.76a6.32 6.32 0 016.19-5.75 5.25 5.25 0 015.31 5.75z"
                    style={{
                        transformOrigin: "325.487px 115.775px"
                    }}
                    className="animable"
                    fill="#fff"
                    opacity={0.4}
                />
                <path
                    style={{
                        transformOrigin: "315.145px 251.585px"
                    }}
                    className="animable"
                    d="M379.59 372.5L231.85 372.5 250.71 130.67 398.44 130.67 379.59 372.5z"
                    fill="#fff"
                />
                <path
                    d="M347.2 143.33H300a5.38 5.38 0 01-5.43-5.9l.6-7.68a6.49 6.49 0 016.35-5.9h47.21a5.39 5.39 0 015.44 5.9l-.6 7.68a6.51 6.51 0 01-6.37 5.9zm-45.86-17.47a4.28 4.28 0 00-4.19 3.89l-.6 7.68a3.55 3.55 0 003.58 3.9h47.22a4.29 4.29 0 004.2-3.9l.6-7.68a3.56 3.56 0 00-3.59-3.89z"
                    style={{
                        transformOrigin: "324.37px 133.59px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <g
                    style={{
                        transformOrigin: "324.37px 133.59px"
                    }}
                    className="animable"
                    opacity={0.4}
                >
                    <path
                        d="M347.2 143.33H300a5.38 5.38 0 01-5.43-5.9l.6-7.68a6.49 6.49 0 016.35-5.9h47.21a5.39 5.39 0 015.44 5.9l-.6 7.68a6.51 6.51 0 01-6.37 5.9zm-45.86-17.47a4.28 4.28 0 00-4.19 3.89l-.6 7.68a3.55 3.55 0 003.58 3.9h47.22a4.29 4.29 0 004.2-3.9l.6-7.68a3.56 3.56 0 00-3.59-3.89z"
                        style={{
                            transformOrigin: "324.37px 133.59px"
                        }}
                        className="animable"
                        fill="#fff"
                    />
                </g>
                <path
                    d="M344.76 128.28h-40a1.25 1.25 0 01-1.27-1.37l.31-4a1.52 1.52 0 011.49-1.37h40a1.24 1.24 0 011.26 1.37l-.31 4a1.51 1.51 0 01-1.48 1.37z"
                    style={{
                        transformOrigin: "325.021px 124.91px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "323.105px 159.89px"
                    }}
                    className="animable"
                    d="M378.63 166L266.63 166 267.58 153.78 379.58 153.78 378.63 166z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "296.145px 181.435px"
                    }}
                    className="animable"
                    d="M333.3 183.01L258.74 183.01 258.99 179.86 333.55 179.86 333.3 183.01z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "295.44px 190.53px"
                    }}
                    className="animable"
                    d="M332.6 192.11L258.04 192.11 258.28 188.95 332.84 188.95 332.6 192.11z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "294.73px 199.63px"
                    }}
                    className="animable"
                    d="M331.89 201.21L257.33 201.21 257.57 198.05 332.13 198.05 331.89 201.21z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "294.02px 208.725px"
                    }}
                    className="animable"
                    d="M331.18 210.3L256.62 210.3 256.86 207.15 331.42 207.15 331.18 210.3z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "366.08px 195.08px"
                    }}
                    className="animable"
                    d="M380.1 210.3L349.68 210.3 352.06 179.86 382.48 179.86 380.1 210.3z"
                    fill="#ff95cd"
                />
                <path
                    d="M371.68 191.16c.14-1.78-1.24-3-3.74-3a6.44 6.44 0 00-5.16 2.2l-1.92-1.45a9.41 9.41 0 017.45-3.12c4 0 6.46 1.87 6.21 5-.36 4.65-5.31 5-5.59 8.61h-2.79c.35-4.4 5.29-5.04 5.54-8.24zm-6.28 12.73a1.92 1.92 0 012-1.78 1.59 1.59 0 011.64 1.78 1.93 1.93 0 01-1.92 1.78 1.61 1.61 0 01-1.72-1.78z"
                    style={{
                        transformOrigin: "367.699px 195.727px"
                    }}
                    className="animable"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "292.555px 227.5px"
                    }}
                    className="animable"
                    d="M329.71 229.08L255.15 229.08 255.4 225.92 329.96 225.92 329.71 229.08z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "291.845px 236.595px"
                    }}
                    className="animable"
                    d="M329 238.17L254.44 238.17 254.69 235.02 329.25 235.02 329 238.17z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "291.14px 245.695px"
                    }}
                    className="animable"
                    d="M328.3 247.27L253.74 247.27 253.98 244.12 328.54 244.12 328.3 247.27z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "290.43px 254.79px"
                    }}
                    className="animable"
                    d="M327.59 256.37L253.03 256.37 253.27 253.21 327.83 253.21 327.59 256.37z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "362.485px 241.145px"
                    }}
                    className="animable"
                    d="M376.51 256.37L346.09 256.37 348.46 225.92 378.88 225.92 376.51 256.37z"
                    fill="#ff95cd"
                />
                <path
                    d="M368.09 237.23c.14-1.79-1.24-3-3.74-3a6.44 6.44 0 00-5.16 2.2l-1.92-1.43a9.38 9.38 0 017.45-3.12c4 0 6.46 1.87 6.21 5-.36 4.65-5.31 5-5.59 8.61h-2.79c.34-4.49 5.29-5.06 5.54-8.26zM361.81 250a1.92 1.92 0 011.95-1.79 1.59 1.59 0 011.64 1.79 1.94 1.94 0 01-1.92 1.78 1.61 1.61 0 01-1.67-1.78z"
                    style={{
                        transformOrigin: "364.109px 241.825px"
                    }}
                    className="animable"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "288.965px 273.565px"
                    }}
                    className="animable"
                    d="M326.12 275.14L251.56 275.14 251.81 271.99 326.37 271.99 326.12 275.14z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "288.255px 282.66px"
                    }}
                    className="animable"
                    d="M325.41 284.24L250.85 284.24 251.1 281.08 325.66 281.08 325.41 284.24z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "287.55px 291.76px"
                    }}
                    className="animable"
                    d="M324.7 293.34L250.15 293.34 250.39 290.18 324.95 290.18 324.7 293.34z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "286.84px 300.855px"
                    }}
                    className="animable"
                    d="M324 302.43L249.44 302.43 249.68 299.28 324.24 299.28 324 302.43z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "358.895px 287.21px"
                    }}
                    className="animable"
                    d="M372.92 302.43L342.5 302.43 344.87 271.99 375.29 271.99 372.92 302.43z"
                    fill="#ff95cd"
                />
                <path
                    d="M364.5 283.29c.14-1.78-1.24-3-3.75-3a6.43 6.43 0 00-5.15 2.2l-1.92-1.49a9.38 9.38 0 017.45-3.12c4 0 6.45 1.86 6.21 4.95-.36 4.66-5.31 5-5.59 8.61H359c.3-4.33 5.25-4.95 5.5-8.15zM358.22 296a1.92 1.92 0 011.95-1.78 1.59 1.59 0 011.64 1.78 1.93 1.93 0 01-1.92 1.78 1.6 1.6 0 01-1.67-1.78z"
                    style={{
                        transformOrigin: "360.518px 287.826px"
                    }}
                    className="animable"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "285.375px 319.63px"
                    }}
                    className="animable"
                    d="M322.53 321.21L247.97 321.21 248.22 318.05 322.78 318.05 322.53 321.21z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "284.665px 328.73px"
                    }}
                    className="animable"
                    d="M321.82 330.31L247.26 330.31 247.51 327.15 322.07 327.15 321.82 330.31z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "283.955px 337.825px"
                    }}
                    className="animable"
                    d="M321.11 339.4L246.55 339.4 246.8 336.25 321.36 336.25 321.11 339.4z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "283.245px 346.92px"
                    }}
                    className="animable"
                    d="M320.4 348.5L245.84 348.5 246.09 345.34 320.65 345.34 320.4 348.5z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "355.305px 333.275px"
                    }}
                    className="animable"
                    d="M369.33 348.5L338.91 348.5 341.28 318.05 371.7 318.05 369.33 348.5z"
                    fill="#ff95cd"
                />
                <path
                    d="M360.91 329.36c.14-1.79-1.24-3-3.75-3a6.42 6.42 0 00-5.15 2.2l-1.92-1.45a9.38 9.38 0 017.45-3.12c4 0 6.45 1.87 6.21 5-.36 4.65-5.31 5-5.59 8.61h-2.79c.34-4.43 5.29-5.04 5.54-8.24zm-6.28 12.73a1.92 1.92 0 011.95-1.79 1.59 1.59 0 011.64 1.79 1.94 1.94 0 01-1.92 1.78 1.61 1.61 0 01-1.67-1.78z"
                    style={{
                        transformOrigin: "356.928px 333.925px"
                    }}
                    className="animable"
                    fill="#fff"
                />
                <path
                    style={{
                        transformOrigin: "323.105px 159.89px"
                    }}
                    className="animable"
                    d="M378.63 166L266.63 166 267.58 153.78 379.58 153.78 378.63 166z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "296.145px 181.435px"
                    }}
                    className="animable"
                    d="M333.3 183.01L258.74 183.01 258.99 179.86 333.55 179.86 333.3 183.01z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "295.44px 190.53px"
                    }}
                    className="animable"
                    d="M332.6 192.11L258.04 192.11 258.28 188.95 332.84 188.95 332.6 192.11z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "294.73px 199.63px"
                    }}
                    className="animable"
                    d="M331.89 201.21L257.33 201.21 257.57 198.05 332.13 198.05 331.89 201.21z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "294.02px 208.725px"
                    }}
                    className="animable"
                    d="M331.18 210.3L256.62 210.3 256.86 207.15 331.42 207.15 331.18 210.3z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "366.08px 195.08px"
                    }}
                    className="animable"
                    d="M380.1 210.3L349.68 210.3 352.06 179.86 382.48 179.86 380.1 210.3z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "292.555px 227.5px"
                    }}
                    className="animable"
                    d="M329.71 229.08L255.15 229.08 255.4 225.92 329.96 225.92 329.71 229.08z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "291.845px 236.595px"
                    }}
                    className="animable"
                    d="M329 238.17L254.44 238.17 254.69 235.02 329.25 235.02 329 238.17z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "291.14px 245.695px"
                    }}
                    className="animable"
                    d="M328.3 247.27L253.74 247.27 253.98 244.12 328.54 244.12 328.3 247.27z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "290.43px 254.79px"
                    }}
                    className="animable"
                    d="M327.59 256.37L253.03 256.37 253.27 253.21 327.83 253.21 327.59 256.37z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "362.485px 241.145px"
                    }}
                    className="animable"
                    d="M376.51 256.37L346.09 256.37 348.46 225.92 378.88 225.92 376.51 256.37z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "288.965px 273.565px"
                    }}
                    className="animable"
                    d="M326.12 275.14L251.56 275.14 251.81 271.99 326.37 271.99 326.12 275.14z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "288.255px 282.66px"
                    }}
                    className="animable"
                    d="M325.41 284.24L250.85 284.24 251.1 281.08 325.66 281.08 325.41 284.24z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "287.55px 291.76px"
                    }}
                    className="animable"
                    d="M324.7 293.34L250.15 293.34 250.39 290.18 324.95 290.18 324.7 293.34z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "286.84px 300.855px"
                    }}
                    className="animable"
                    d="M324 302.43L249.44 302.43 249.68 299.28 324.24 299.28 324 302.43z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "358.895px 287.21px"
                    }}
                    className="animable"
                    d="M372.92 302.43L342.5 302.43 344.87 271.99 375.29 271.99 372.92 302.43z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "285.375px 319.63px"
                    }}
                    className="animable"
                    d="M322.53 321.21L247.97 321.21 248.22 318.05 322.78 318.05 322.53 321.21z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "284.665px 328.73px"
                    }}
                    className="animable"
                    d="M321.82 330.31L247.26 330.31 247.51 327.15 322.07 327.15 321.82 330.31z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "283.955px 337.825px"
                    }}
                    className="animable"
                    d="M321.11 339.4L246.55 339.4 246.8 336.25 321.36 336.25 321.11 339.4z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "283.245px 346.92px"
                    }}
                    className="animable"
                    d="M320.4 348.5L245.84 348.5 246.09 345.34 320.65 345.34 320.4 348.5z"
                    fill="#fff"
                    opacity={0.7}
                />
                <path
                    style={{
                        transformOrigin: "355.305px 333.275px"
                    }}
                    className="animable"
                    d="M369.33 348.5L338.91 348.5 341.28 318.05 371.7 318.05 369.33 348.5z"
                    fill="#fff"
                    opacity={0.7}
                />
            </g>
            <g
                className="animable"
                style={{
                    transformOrigin: "151.814px 318.835px"
                }}
            >
                <path
                    d="M200 257v27.54a21 21 0 01-5.85 14.57L168.45 326H183l26.7-26.28a21.08 21.08 0 006.3-15V257z"
                    style={{
                        transformOrigin: "192.225px 291.5px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <path
                    d="M216 257v27.69a20.24 20.24 0 01-.52 4.61 20.91 20.91 0 01-5.78 10.42L183 326h-14.55l25.7-26.89a21 21 0 005.85-14.57V257z"
                    style={{
                        transformOrigin: "192.225px 291.5px"
                    }}
                    className="animable"
                    fill="#fff"
                    opacity={0.4}
                />
                <path
                    d="M216 257v27.69a20.24 20.24 0 01-.52 4.61L200 283.05V257z"
                    style={{
                        isolation: "isolate",
                        transformOrigin: "208px 273.15px"
                    }}
                    className="animable"
                    opacity={0.2}
                />
                <path
                    d="M158.34 329l-21.54 82.06a3.48 3.48 0 01-3.37 2.61H94.94a2.08 2.08 0 01-1.64-.81 2.05 2.05 0 01-.36-1.79L114.49 329h-4.14l-21.28 81.05a6.09 6.09 0 005.87 7.62h38.49a7.49 7.49 0 007.24-5.59l21.8-83.08z"
                    style={{
                        transformOrigin: "125.672px 373.335px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <g
                    style={{
                        isolation: "isolate",
                        transformOrigin: "125.672px 373.335px"
                    }}
                    className="animable"
                    opacity={0.4}
                >
                    <path
                        d="M158.34 329l-21.54 82.06a3.48 3.48 0 01-3.37 2.61H94.94a2.08 2.08 0 01-1.64-.81 2.05 2.05 0 01-.36-1.79L114.49 329h-4.14l-21.28 81.05a6.09 6.09 0 005.87 7.62h38.49a7.49 7.49 0 007.24-5.59l21.8-83.08z"
                        style={{
                            transformOrigin: "125.672px 373.335px"
                        }}
                        className="animable"
                        fill="#fff"
                    />
                </g>
                <path
                    style={{
                        transformOrigin: "153.44px 372.77px"
                    }}
                    className="animable"
                    d="M167.15 417.67L143.6 327.87 139.73 328.88 163.01 417.67 167.15 417.67z"
                    fill="#ff95cd"
                />
                <path
                    style={{
                        transformOrigin: "201.44px 372.77px"
                    }}
                    className="animable"
                    d="M215.15 417.67L191.6 327.87 187.73 328.88 211.01 417.67 215.15 417.67z"
                    fill="#ff95cd"
                />
                <g
                    style={{
                        transformOrigin: "153.44px 372.77px"
                    }}
                    className="animable"
                    opacity={0.5}
                >
                    <path
                        style={{
                            transformOrigin: "153.44px 372.77px"
                        }}
                        className="animable"
                        d="M167.15 417.67L143.6 327.87 139.73 328.88 163.01 417.67 167.15 417.67z"
                        fill="#fff"
                    />
                </g>
                <g
                    style={{
                        transformOrigin: "201.44px 372.77px"
                    }}
                    className="animable"
                    opacity={0.5}
                >
                    <path
                        style={{
                            transformOrigin: "201.44px 372.77px"
                        }}
                        className="animable"
                        d="M215.15 417.67L191.6 327.87 187.73 328.88 211.01 417.67 215.15 417.67z"
                        fill="#fff"
                    />
                </g>
                <path
                    style={{
                        isolation: "isolate",
                        transformOrigin: "110.95px 335.185px"
                    }}
                    className="animable"
                    d="M110.35 329L114.49 329 111.24 341.37 107.41 340.2 110.35 329z"
                    opacity={0.2}
                />
                <path
                    style={{
                        isolation: "isolate",
                        transformOrigin: "144.34px 338.075px"
                    }}
                    className="animable"
                    d="M143.6 327.87L148.95 348.28 144.46 346.92 139.73 328.88 143.6 327.87z"
                    opacity={0.2}
                />
                <path
                    style={{
                        isolation: "isolate",
                        transformOrigin: "157.16px 341.95px"
                    }}
                    className="animable"
                    d="M158.34 329L162.47 329 155.69 354.9 151.85 353.73 158.34 329z"
                    opacity={0.2}
                />
                <path
                    style={{
                        isolation: "isolate",
                        transformOrigin: "194.39px 346.09px"
                    }}
                    className="animable"
                    d="M201.05 364.15L196.54 362.77 187.73 329.13 191.6 328.03 201.05 364.15z"
                    opacity={0.2}
                />
                <path
                    d="M106.7 330.37L88 229.14l-.25-1.53a6.58 6.58 0 011.35-5.41 6.13 6.13 0 014.81-2.2h40.48a8.66 8.66 0 018.06 6.92l.3 1.71 18.69 101-3.94.72-18.75-101.3-.24-1.42a4.62 4.62 0 00-4.12-3.63H93.87a2.18 2.18 0 00-1.74.76 2.63 2.63 0 00-.48 2.17l.28 1.68 18.71 101z"
                    style={{
                        transformOrigin: "124.534px 275.185px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <g
                    style={{
                        isolation: "isolate",
                        transformOrigin: "124.534px 275.185px"
                    }}
                    className="animable"
                    opacity={0.5}
                >
                    <path
                        d="M106.7 330.37L88 229.14l-.25-1.53a6.58 6.58 0 011.35-5.41 6.13 6.13 0 014.81-2.2h40.48a8.66 8.66 0 018.06 6.92l.3 1.71 18.69 101-3.94.72-18.75-101.3-.24-1.42a4.62 4.62 0 00-4.12-3.63H93.87a2.18 2.18 0 00-1.74.76 2.63 2.63 0 00-.48 2.17l.28 1.68 18.71 101z"
                        style={{
                            transformOrigin: "124.534px 275.185px"
                        }}
                        className="animable"
                        fill="#fff"
                    />
                </g>
                <path
                    d="M114.88 320.33h76.93a5 5 0 015 5V332h-86.93v-6.69a5 5 0 015-4.98z"
                    style={{
                        transformOrigin: "153.345px 326.165px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <rect
                    x={106.67}
                    y={326.18}
                    width={93.35}
                    height={5.84}
                    rx={2.01}
                    style={{
                        transformOrigin: "153.345px 329.1px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <rect
                    x={106.67}
                    y={326.18}
                    width={93.35}
                    height={5.84}
                    rx={2.01}
                    style={{
                        isolation: "isolate",
                        transformOrigin: "153.345px 329.1px"
                    }}
                    className="animable"
                    fill="#fff"
                    opacity={0.6}
                />
                <path
                    style={{
                        transformOrigin: "119.125px 249.5px"
                    }}
                    className="animable"
                    d="M148.33 270L97.5 270 89.92 229 140.74 229 148.26 269.62 148.33 270z"
                    fill="#ff95cd"
                />
            </g>
            <g
                className="animable"
                style={{
                    transformOrigin: "184.919px 285.013px"
                }}
            >
                <g
                    className="animable"
                    style={{
                        transformOrigin: "171.131px 285.013px"
                    }}
                >
                    <path
                        d="M198.33 182.63s-6.39-14.84-6.94-16.43.1-9.62-.39-11-7.91-2.37-9.48-2.19-.19 12.6.46 13.58a18 18 0 002.85 2.72l5.65 17z"
                        style={{
                            transformOrigin: "189.563px 169.649px"
                        }}
                        className="animable"
                        fill="#b97964"
                    />
                    <path
                        d="M166 210.64c4.36.69 22.21 3.27 26.2.61 3.22-2.15-5.85-37-5.85-37l8.07-3.29s19.17 42.22 8.93 51.86c-5.2 4.9-19.82 6.14-40.85 6.14z"
                        style={{
                            transformOrigin: "184.43px 199.96px"
                        }}
                        className="animable"
                        fill="#ff95cd"
                    />
                    <path
                        d="M166 210.64c4.36.69 22.21 3.27 26.2.61 3.22-2.15-5.85-37-5.85-37l8.07-3.29s19.17 42.22 8.93 51.86c-5.2 4.9-19.82 6.14-40.85 6.14z"
                        style={{
                            transformOrigin: "184.43px 199.96px"
                        }}
                        className="animable"
                        fill="#fff"
                        opacity={0.8}
                    />
                    <path
                        d="M173.39 228.86c-3.1.09-6.41.13-9.89.13l3-11.49a25.76 25.76 0 016.89 11.36z"
                        style={{
                            isolation: "isolate",
                            transformOrigin: "168.445px 223.245px"
                        }}
                        className="animable"
                        opacity={0.1}
                    />
                    <path
                        style={{
                            transformOrigin: "201.75px 246.18px"
                        }}
                        className="animable"
                        d="M191.17 234.99L212.33 257.37"
                        fill="none"
                        stroke="#2e353a"
                        strokeMiterlimit={10}
                        strokeWidth="2px"
                    />
                    <path
                        d="M176 248.17s16.15-.5 17.83-.67 8.67-4.17 10.17-4.33 5.5 6.16 6 7.66-11.33 5.5-12.5 5.34a18.38 18.38 0 01-3.67-1.44l-17.83 2.1z"
                        style={{
                            transformOrigin: "193.008px 249.998px"
                        }}
                        className="animable"
                        fill="#b97964"
                    />
                    <path
                        style={{
                            transformOrigin: "171.035px 399.815px"
                        }}
                        className="animable"
                        d="M166.5 409.83L174.47 408.74 175.57 389.8 167.62 390.9 166.5 409.83z"
                        fill="#b97964"
                    />
                    <path
                        d="M175.07 407.78l-9-.57a.59.59 0 00-.63.51l-.88 7.1a1.41 1.41 0 001.31 1.5c3.14.15 4.65.06 8.61.28 2.44.14 7.23.66 10.58.33s2.94-3.63 1.5-3.79c-3.44-.39-8-2.91-10.14-4.83a2.24 2.24 0 00-1.35-.53z"
                        style={{
                            transformOrigin: "176.093px 412.123px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M177.83 409.32a10.21 10.21 0 01-2.12-.42.19.19 0 01-.14-.15.22.22 0 01.09-.19c.27-.16 2.64-1.57 3.6-1.13a.7.7 0 01.39.56 1 1 0 01-.29 1 2.16 2.16 0 01-1.53.33zm1.27-1.51c-.51-.24-1.89.35-2.86.88 1.42.37 2.47.39 2.88.05a.7.7 0 00.17-.66.32.32 0 00-.19-.27z"
                        style={{
                            transformOrigin: "177.627px 408.346px"
                        }}
                        className="animable"
                        fill="#ff95cd"
                    />
                    <path
                        d="M175.75 408.9a.12.12 0 01-.08 0 .25.25 0 01-.1-.15c0-.07 0-2.42.82-3.15a1 1 0 01.82-.21.71.71 0 01.64.6c.13.89-1.17 2.49-2 2.91a.12.12 0 01-.1 0zm1.3-3.12a.53.53 0 00-.41.15c-.52.43-.65 1.75-.68 2.5a3.93 3.93 0 001.52-2.34c0-.11-.07-.25-.34-.3z"
                        style={{
                            transformOrigin: "176.715px 407.142px"
                        }}
                        className="animable"
                        fill="#ff95cd"
                    />
                    <path
                        style={{
                            isolation: "isolate",
                            transformOrigin: "171.285px 395.57px"
                        }}
                        className="animable"
                        d="M167.62 390.9L175.57 389.81 174.94 400.63 167 401.33 167.62 390.9z"
                        opacity={0.2}
                    />
                    <path
                        d="M166.82 298.51l-1.94-12.18-44.66-2.67s-4.75 25.34-1.1 32.09c6.51 12.05 41.62 6 51.89 7.15-6.14 25.11-5.54 74.18-5.54 74.18l14.67 1.12s11.29-52.87 13.57-78c1.54-16.95-12.51-16.53-26.89-21.69z"
                        style={{
                            transformOrigin: "155.783px 340.93px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        style={{
                            transformOrigin: "173.205px 394.705px"
                        }}
                        className="animable"
                        d="M163.75 397.77L181.38 398.93 182.89 391.38 163.52 390.48 163.75 397.77z"
                        fill="#ff95cd"
                    />
                    <path
                        style={{
                            transformOrigin: "191.4px 393.915px"
                        }}
                        className="animable"
                        d="M184.88 402.76L192.9 403.35 197.92 385.06 189.91 384.48 184.88 402.76z"
                        fill="#b97964"
                    />
                    <path
                        d="M193.69 402.53l-8.69-2.42a.57.57 0 00-.72.36l-2.34 6.76a1.42 1.42 0 001 1.75c3 .79 4.53 1 8.36 2.06 2.35.65 6.93 2.15 10.28 2.53s3.63-2.94 2.25-3.39c-3.28-1.1-7.2-4.52-8.91-6.84a2.23 2.23 0 00-1.23-.81z"
                        style={{
                            transformOrigin: "193.249px 406.841px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M196.07 404.62a9.5 9.5 0 01-2-.86.16.16 0 01-.1-.17.2.2 0 01.12-.17c.29-.1 2.91-1 3.75-.35a.7.7 0 01.28.63 1 1 0 01-.51.94 2.13 2.13 0 01-1.54-.02zm1.55-1.22c-.45-.34-1.92 0-3 .27 1.31.66 2.34.9 2.8.65a.69.69 0 00.31-.61.31.31 0 00-.13-.31z"
                        style={{
                            transformOrigin: "196.046px 403.805px"
                        }}
                        className="animable"
                        fill="#ff95cd"
                    />
                    <path
                        d="M194.12 403.78H194a.19.19 0 01-.06-.17c0-.07.47-2.37 1.45-2.91a1 1 0 01.84 0 .73.73 0 01.51.73c-.07.89-1.67 2.19-2.57 2.43a.14.14 0 01-.05-.08zM196 401a.54.54 0 00-.43.06c-.6.32-1 1.58-1.19 2.31.82-.38 1.9-1.39 2-2 0-.11 0-.25-.27-.35z"
                        style={{
                            transformOrigin: "195.339px 402.234px"
                        }}
                        className="animable"
                        fill="#ff95cd"
                    />
                    <path
                        style={{
                            isolation: "isolate",
                            transformOrigin: "192.525px 390px"
                        }}
                        className="animable"
                        d="M189.91 384.48L197.92 385.07 195.05 395.52 187.13 394.55 189.91 384.48z"
                        opacity={0.2}
                    />
                    <path
                        d="M200.64 394.23l-14.12-4.15S195 342.5 203.5 326c-.64-.21-1.49-.48-2.54-.79-1.89-.57-4.4-1.28-7.35-2.1-20.52-5.69-62.11-16.36-62.11-16.36l19-17.73s75.68 11.54 77.25 31.48c.75 9.59-27.11 73.73-27.11 73.73z"
                        style={{
                            transformOrigin: "179.632px 341.625px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        style={{
                            transformOrigin: "194.725px 389.205px"
                        }}
                        className="animable"
                        d="M184.7 390.39L201.7 395.2 204.75 388.13 185.99 383.21 184.7 390.39z"
                        fill="#ff95cd"
                    />
                    <path
                        d="M201 325.21c-1.89-.57-4.4-1.28-7.35-2.1.59-4.84.6-10.39-1.73-13.22-4.63-5.64-16.54-8.95-23.32-10.15-5.67-1-24.72-3-24.72-3s24.72-2.37 50 5c12.44 3.66 10.01 15.87 7.12 23.47z"
                        style={{
                            isolation: "isolate",
                            transformOrigin: "173.605px 310.793px"
                        }}
                        className="animable"
                        opacity={0.2}
                    />
                    <path
                        d="M166 210.64s6.48 24-1.09 75.69c-14.11-.3-37.82-.85-44.69-1-.17-7.2 5.14-42.48-1.07-76.51a94.38 94.38 0 0113.53-1.34 174 174 0 0119.91.43 88.8 88.8 0 0113.41 2.73z"
                        style={{
                            transformOrigin: "143.866px 246.85px"
                        }}
                        className="animable"
                        fill="#ff95cd"
                    />
                    <path
                        d="M166 210.64s6.48 24-1.09 75.69c-14.11-.3-37.82-.85-44.69-1-.17-7.2 5.14-42.48-1.07-76.51a94.38 94.38 0 0113.53-1.34 174 174 0 0119.91.43 88.8 88.8 0 0113.41 2.73z"
                        style={{
                            transformOrigin: "143.866px 246.85px"
                        }}
                        className="animable"
                        fill="#fff"
                        opacity={0.7}
                    />
                    <path
                        d="M134.83 252.67c-4-.88-8.77-4.73-12.7-8.53 0-6.76-.33-13.95-1.06-21.28 5.56 8.23 20.62 31.32 13.76 29.81z"
                        style={{
                            isolation: "isolate",
                            transformOrigin: "128.829px 237.8px"
                        }}
                        className="animable"
                        opacity={0.1}
                    />
                    <path
                        d="M119.12 208.82c-15.29 5.51 11.55 46.91 19.88 51.18s50.67-4.67 50.67-4.67l-1.67-8.56s-37.46.95-40.91.08-11.65-18.52-16.37-26.85a26.71 26.71 0 00-11.6-11.18z"
                        style={{
                            transformOrigin: "152.084px 234.988px"
                        }}
                        className="animable"
                        fill="#ff95cd"
                    />
                    <path
                        d="M119.12 208.82c-15.29 5.51 11.55 46.91 19.88 51.18s50.67-4.67 50.67-4.67l-1.67-8.56s-37.46.95-40.91.08-11.65-18.52-16.37-26.85a26.71 26.71 0 00-11.6-11.18z"
                        style={{
                            transformOrigin: "152.084px 234.988px"
                        }}
                        className="animable"
                        fill="#fff"
                        opacity={0.8}
                    />
                    <path
                        style={{
                            transformOrigin: "188.085px 251.685px"
                        }}
                        className="animable"
                        d="M185 246L187.17 257.37 191.17 256 189.67 246 185 246z"
                        fill="#ff95cd"
                    />
                    <path
                        style={{
                            transformOrigin: "188.085px 251.685px"
                        }}
                        className="animable"
                        d="M185 246L187.17 257.37 191.17 256 189.67 246 185 246z"
                        fill="#fff"
                        opacity={0.7}
                    />
                    <path
                        style={{
                            transformOrigin: "191.02px 172.815px"
                        }}
                        className="animable"
                        d="M186.08 176.78L196.84 172.52 194.75 168.85 185.2 172.19 186.08 176.78z"
                        fill="#ff95cd"
                    />
                    <path
                        style={{
                            transformOrigin: "191.02px 172.815px"
                        }}
                        className="animable"
                        d="M186.08 176.78L196.84 172.52 194.75 168.85 185.2 172.19 186.08 176.78z"
                        fill="#fff"
                        opacity={0.7}
                    />
                    <path
                        d="M130.24 207.58s.29 4.67 9.46 9.17l6.34-4.59s1.81 11.72 3 20.47c0 0-.08-14-1.28-19.38l4.85 1.72s-4.13-7.09-11.16-8.72-11.21 1.33-11.21 1.33z"
                        style={{
                            isolation: "isolate",
                            transformOrigin: "141.425px 219.195px"
                        }}
                        className="animable"
                        opacity={0.1}
                    />
                    <path
                        d="M135.1 185.16c1.12 6.43 2.12 18.19-2.45 22.37l13.35 3.72 6.52-3.29c-7.11-1.86-6.81-7.16-5.46-12.11z"
                        style={{
                            transformOrigin: "142.585px 198.205px"
                        }}
                        className="animable"
                        fill="#b97964"
                    />
                    <path
                        d="M140 189.52l7.1 6.33a21.27 21.27 0 00-.69 3.52c-2.72-.45-6.4-3.53-6.63-6.39a9.39 9.39 0 01.22-3.46z"
                        style={{
                            isolation: "isolate",
                            transformOrigin: "143.405px 194.445px"
                        }}
                        className="animable"
                        opacity={0.2}
                    />
                    <path
                        d="M144.57 167.29c-2.91 3.16-.4 6.77 8.89 11.16 2.21-4.87.86-13-2.14-14.42s-4.21.52-6.75 3.26z"
                        style={{
                            transformOrigin: "148.989px 171.001px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M131.2 177.23c2.36 8.37 3.32 13.38 8.54 16.81 7.86 5.15 17.49-1 17.68-9.91.16-8-3.72-20.35-12.75-21.92a11.86 11.86 0 00-13.47 15z"
                        style={{
                            transformOrigin: "144.075px 178.971px"
                        }}
                        className="animable"
                        fill="#b97964"
                    />
                    <path
                        d="M144.37 176.81c.15.69.64 1.17 1.09 1.07s.69-.73.54-1.42-.63-1.17-1.08-1.08-.65.74-.55 1.43z"
                        style={{
                            transformOrigin: "145.195px 176.631px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M152.22 175.12c.15.69.64 1.17 1.09 1.07s.7-.73.55-1.43-.64-1.17-1.09-1.07-.7.74-.55 1.43z"
                        style={{
                            transformOrigin: "153.04px 174.94px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M149.73 176a24.9 24.9 0 004.58 5.19 4.08 4.08 0 01-3.17 1.33z"
                        style={{
                            transformOrigin: "152.02px 179.261px"
                        }}
                        className="animable"
                        fill="#a24e3f"
                    />
                    <path
                        d="M141.69 174.8a.39.39 0 01-.48-.55 4.1 4.1 0 012.94-2.39.41.41 0 01.47.32.43.43 0 01-.35.47 3.27 3.27 0 00-2.3 1.91.4.4 0 01-.28.24z"
                        style={{
                            transformOrigin: "142.893px 173.339px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M155.22 171.7a.4.4 0 01-.42-.15 3.32 3.32 0 00-2.68-1.34.42.42 0 01-.45-.38.43.43 0 01.37-.45 4.14 4.14 0 013.41 1.66.41.41 0 01-.07.58.35.35 0 01-.16.08z"
                        style={{
                            transformOrigin: "153.604px 170.546px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M133 169c4.26.5 4.7 4.88.5 14.25-4.85-2.26-9.12-9.32-7.75-12.34s3.48-2.36 7.25-1.91z"
                        style={{
                            transformOrigin: "130.961px 175.929px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M128.63 184.89a8.25 8.25 0 004.89 4c2.78.81 4.2-1.67 3.46-4.31-.67-2.38-2.93-5.67-5.73-5.32s-3.88 3.26-2.62 5.63z"
                        style={{
                            transformOrigin: "132.641px 184.14px"
                        }}
                        className="animable"
                        fill="#b97964"
                    />
                    <path
                        d="M126.08 170.19s-2.11-2.72 2-8.16 14.15-7.11 21.85-5.61 3.12 10 .37 11.41l.34-1.33a23 23 0 01-9.5 2.58l1.52-1.41s-12.08 3.13-16.58 2.52z"
                        style={{
                            transformOrigin: "139.86px 163.082px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M150.63 184.82a20.79 20.79 0 00-.29 3.11l-.54.08c-2.48.33-3.73-.34-4.37-1.17a3.31 3.31 0 01-.59-1.41 3.08 3.08 0 010-.87 11.73 11.73 0 005 .36c.46-.04.79-.1.79-.1z"
                        style={{
                            transformOrigin: "147.72px 186.328px"
                        }}
                        className="animable"
                        fill="#2e353a"
                    />
                    <path
                        d="M149.78 184.92l-.11.92c-2.32.3-4 .2-4.83-.41a3.08 3.08 0 010-.87 11.73 11.73 0 004.94.36z"
                        style={{
                            transformOrigin: "147.295px 185.282px"
                        }}
                        className="animable"
                        fill="#fff"
                    />
                    <path
                        d="M149.8 188c-2.48.33-3.73-.34-4.37-1.17a8 8 0 012.81.18 3 3 0 011.56.99z"
                        style={{
                            transformOrigin: "147.615px 187.432px"
                        }}
                        className="animable"
                        fill="#a24e3f"
                    />
                    <path
                        d="M135 203.58s7.22 5.42 11 6.67c0 0 1.78-3.34 1.05-6.1l5.47 3.81a13.51 13.51 0 010 7l-6.52-3.71-6.16 4.5s-9.11-2.64-9.64-8.17z"
                        style={{
                            transformOrigin: "141.591px 209.665px"
                        }}
                        className="animable"
                        fill="#ff95cd"
                    />
                    <path
                        d="M135 203.58s7.22 5.42 11 6.67c0 0 1.78-3.34 1.05-6.1l5.47 3.81a13.51 13.51 0 010 7l-6.52-3.71-6.16 4.5s-9.11-2.64-9.64-8.17z"
                        style={{
                            transformOrigin: "141.591px 209.665px"
                        }}
                        className="animable"
                        fill="#fff"
                        opacity={0.8}
                    />
                </g>
                <rect
                    x={153.33}
                    y={254.87}
                    width={102.01}
                    height={5.27}
                    rx={1.17}
                    style={{
                        transformOrigin: "204.335px 257.505px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <path
                    d="M255 255.9v2.93c0 .65-.18 1.17-.82 1.17H154.5c-.65 0-1.5-.52-1.5-1.17v-2.93c0-.64.85-.9 1.5-.9h99.68c.64 0 .82.26.82.9z"
                    style={{
                        transformOrigin: "204px 257.5px"
                    }}
                    className="animable"
                    fill="#fff"
                    opacity={0.5}
                />
                <path
                    d="M195 255.9v2.93c0 .65-.22 1.17-.86 1.17H154.5c-.65 0-1.5-.52-1.5-1.17v-2.93c0-.64.85-.9 1.5-.9h39.64c.64 0 .86.26.86.9z"
                    style={{
                        isolation: "isolate",
                        transformOrigin: "174px 257.5px"
                    }}
                    className="animable"
                    opacity={0.2}
                />
            </g>
            <g
                className="animable"
                style={{
                    transformOrigin: "147.32px 109.596px"
                }}
            >
                <path
                    d="M172.36 109.13a19.13 19.13 0 10-25.91 22.7 5.45 5.45 0 012.89 2.78l.65 1.47 18.41-5-.19-1.6a5.61 5.61 0 011.09-3.89 19.26 19.26 0 003.06-16.46z"
                    style={{
                        transformOrigin: "153.913px 115.584px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <path
                    d="M156 136.12s-2.77-8.69-7.66-12.54l2.71-.74.21-4.17 4.43 6.41-.36-7.8 4.37 7.11.44-4 3.87-1a22.2 22.2 0 00-1.07 15.11"
                    style={{
                        transformOrigin: "156.175px 126.7px"
                    }}
                    className="animable"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M159.48 134.66c-3.26.89-5.08 4.64-4.06 8.37s4.48 6 7.74 5.14 5.07-4.63 4.06-8.36-4.48-6.03-7.74-5.15z"
                    style={{
                        transformOrigin: "161.318px 141.412px"
                    }}
                    className="animable"
                    fill="#2e353a"
                />
                <path
                    d="M165.76 144.74l-6.56 1.79a6.44 6.44 0 01-7.76-4.06l-2.15-6.07a.92.92 0 01.63-1.2l18.08-4.93a.92.92 0 011.15.72l1.23 6.31a6.44 6.44 0 01-4.62 7.44z"
                    style={{
                        transformOrigin: "159.867px 138.496px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <path
                    d="M165.76 144.74l-6.56 1.79a6.44 6.44 0 01-7.76-4.06l-2.15-6.07a.92.92 0 01.63-1.2l18.08-4.93a.92.92 0 011.15.72l1.23 6.31a6.44 6.44 0 01-4.62 7.44z"
                    style={{
                        transformOrigin: "159.867px 138.496px"
                    }}
                    className="animable"
                    fill="#fff"
                    opacity={0.4}
                />
                <path
                    d="M128.38 128.25a31 31 0 00-5.43-.51 22.15 22.15 0 00-2.71.15c-.45.07-.9.12-1.33.23-.22.06-.44.09-.65.17l-.63.2-.72.23.43-.63a24.12 24.12 0 002.87-5.8 17.83 17.83 0 00.75-3.13 14.22 14.22 0 00.14-1.59 14.06 14.06 0 000-1.59 11.71 11.71 0 00-.22-1.56l-.19-.76-.25-.75a9.55 9.55 0 00-.65-1.42 11.26 11.26 0 00-.83-1.32 13.16 13.16 0 00-1-1.2l-.55-.56-.6-.52c-.39-.36-.85-.64-1.26-1s-.9-.56-1.35-.85l-1-.66 1.11-.53c.53-.26 1.09-.57 1.62-.89s1.06-.65 1.58-1a26.18 26.18 0 002.93-2.32c.45-.42.89-.85 1.32-1.3s.82-.93 1.19-1.41.73-1 1-1.51a14.46 14.46 0 00.87-1.59 13.42 13.42 0 00.68-1.68l.26-.86.19-.89a11.83 11.83 0 00.2-1.78 13.6 13.6 0 00-.32-3.59l-.2-.89-.28-.87c-.17-.59-.44-1.14-.66-1.71s-.54-1.1-.81-1.66l-1.43-3 2.74 1.76c.48.32 1 .63 1.57.92s1.1.57 1.66.82a27.14 27.14 0 003.44 1.33c.59.17 1.18.33 1.77.46a15.55 15.55 0 001.79.3 13.54 13.54 0 001.79.11 14.75 14.75 0 001.77-.12l.86-.15.85-.23a11.71 11.71 0 001.6-.66 5.48 5.48 0 00.74-.43 5 5 0 00.71-.5 13 13 0 001.3-1.16 13.28 13.28 0 001.11-1.37 12.49 12.49 0 00.95-1.52c.31-.51.52-1.09.79-1.63s.43-1.14.65-1.71l1.25-3.28.62 3.42a12.2 12.2 0 00.43 1.65 15.65 15.65 0 002.38 4.65 12.11 12.11 0 002.43 2.42 10.34 10.34 0 001.44.92 11 11 0 001.57.7 13.12 13.12 0 001.66.46 14.39 14.39 0 001.73.24 17 17 0 001.75 0c.59 0 1.18-.08 1.77-.13s1.18-.19 1.76-.28l1.75-.42 1.73-.52 1.71-.61 2.37-.85-1.36 2.11c-.25.37-.5.82-.73 1.25s-.44.87-.64 1.33a16.21 16.21 0 00-.93 2.78 12.16 12.16 0 00-.33 2.87 8.69 8.69 0 00.49 2.78l.27.66.34.73a8.62 8.62 0 00.83 1.15 9.73 9.73 0 001 1 11.27 11.27 0 001.17.89 13.15 13.15 0 001.26.76c.43.24.89.42 1.34.64l1.4.53 1.44.45 1 .32-.84.65a14.17 14.17 0 00-1.59 1.44 15.57 15.57 0 00-1.38 1.66c-.23.29-.41.6-.61.9a8.62 8.62 0 00-.52.94 6.23 6.23 0 00-.44 1 6.07 6.07 0 00-.33 1c-.07.35-.19.69-.23 1l-.1 1.07c0 .36 0 .72.06 1.08a4.8 4.8 0 00.18 1.06 6.25 6.25 0 00.28 1l.41 1a5.89 5.89 0 00.51 1l.56 1 .21.35h-.39a17.17 17.17 0 00-4.38.58 9.59 9.59 0 00-2.06.81 4.57 4.57 0 00-.47.29 2.36 2.36 0 00-.45.33 3.62 3.62 0 00-.42.36l-.39.41.37-.43a3 3 0 01.4-.39 3.13 3.13 0 01.44-.36c.15-.1.3-.22.46-.31a10.27 10.27 0 012.05-.94 16.38 16.38 0 014.45-.79l-.17.35-.62-1a6 6 0 01-.58-1l-.47-1a5.85 5.85 0 01-.34-1.1 4.84 4.84 0 01-.24-1.13c0-.38-.09-.77-.1-1.15v-1.17c0-.38.14-.76.2-1.14a7.17 7.17 0 01.32-1.12 6.23 6.23 0 01.43-1.08 8.28 8.28 0 01.52-1 10.85 10.85 0 01.6-1 15.58 15.58 0 011.43-1.81 15.24 15.24 0 011.69-1.61l.19 1-1.51-.43-1.49-.53c-.49-.21-1-.4-1.46-.65a12.73 12.73 0 01-1.39-.79 12.13 12.13 0 01-1.31-.95 9.68 9.68 0 01-1.14-1.14 9.18 9.18 0 01-1-1.33l-.41-.72-.33-.77a10 10 0 01-.64-3.18 13.07 13.07 0 01.29-3.25 18.15 18.15 0 01.94-3.07c.2-.5.42-1 .66-1.46s.49-.94.8-1.43l1 1.26-1.78.65-1.81.56c-.62.17-1.24.31-1.86.46s-1.25.24-1.89.31a17.72 17.72 0 01-1.93.16 18.15 18.15 0 01-2 0 16.12 16.12 0 01-1.94-.26 15.82 15.82 0 01-1.91-.51 14.71 14.71 0 01-1.82-.79 12.29 12.29 0 01-1.69-1.06 14 14 0 01-2.82-2.77 16.38 16.38 0 01-2-3.36 17.56 17.56 0 01-.71-1.82 15.07 15.07 0 01-.52-1.93l1.87.14c-.23.62-.44 1.25-.69 1.86a20 20 0 01-.86 1.81 14 14 0 01-1 1.73 16 16 0 01-1.28 1.6 13.53 13.53 0 01-1.54 1.38 6.17 6.17 0 01-.86.58 8.08 8.08 0 01-.9.52 13.43 13.43 0 01-1.93.78l-1 .25-1 .18a14 14 0 01-2 .11 15 15 0 01-2-.13 18.44 18.44 0 01-2-.35 20.9 20.9 0 01-1.92-.52 27.54 27.54 0 01-3.66-1.44c-.6-.27-1.18-.57-1.75-.88s-1.13-.64-1.72-1l1.31-1.19c.29.6.6 1.18.86 1.8a20 20 0 01.71 1.87l.3 1 .22 1a19.48 19.48 0 01.3 2 17.17 17.17 0 010 2 13.59 13.59 0 01-.24 2l-.22 1-.3 1a15.49 15.49 0 01-.78 1.88 14.32 14.32 0 01-1 1.75 19.18 19.18 0 01-1.18 1.58c-.43.52-.87 1-1.33 1.49s-.95.92-1.44 1.36a30.15 30.15 0 01-3.15 2.37q-.83.54-1.68 1c-.58.32-1.15.62-1.78.9l.07-1.19c.47.32 1 .61 1.42.94s.92.67 1.33 1.07l.64.58.59.62a15.43 15.43 0 011.08 1.34 12.47 12.47 0 01.89 1.49 11.57 11.57 0 01.68 1.58l.25.83.18.84a12.45 12.45 0 01.2 1.71 16.57 16.57 0 01-1.16 6.63 25 25 0 01-3.19 5.86l-.29-.4.67-.19c.23-.07.46-.1.69-.15.45-.1.91-.13 1.37-.19a23.15 23.15 0 012.76 0 31.89 31.89 0 015.43.76z"
                    style={{
                        transformOrigin: "147.32px 99.78px"
                    }}
                    className="animable"
                    fill="#ff95cd"
                />
                <path
                    d="M128.38 128.25a31 31 0 00-5.43-.51 22.15 22.15 0 00-2.71.15c-.45.07-.9.12-1.33.23-.22.06-.44.09-.65.17l-.63.2-.72.23.43-.63a24.12 24.12 0 002.87-5.8 17.83 17.83 0 00.75-3.13 14.22 14.22 0 00.14-1.59 14.06 14.06 0 000-1.59 11.71 11.71 0 00-.22-1.56l-.19-.76-.25-.75a9.55 9.55 0 00-.65-1.42 11.26 11.26 0 00-.83-1.32 13.16 13.16 0 00-1-1.2l-.55-.56-.6-.52c-.39-.36-.85-.64-1.26-1s-.9-.56-1.35-.85l-1-.66 1.11-.53c.53-.26 1.09-.57 1.62-.89s1.06-.65 1.58-1a26.18 26.18 0 002.93-2.32c.45-.42.89-.85 1.32-1.3s.82-.93 1.19-1.41.73-1 1-1.51a14.46 14.46 0 00.87-1.59 13.42 13.42 0 00.68-1.68l.26-.86.19-.89a11.83 11.83 0 00.2-1.78 13.6 13.6 0 00-.32-3.59l-.2-.89-.28-.87c-.17-.59-.44-1.14-.66-1.71s-.54-1.1-.81-1.66l-1.43-3 2.74 1.76c.48.32 1 .63 1.57.92s1.1.57 1.66.82a27.14 27.14 0 003.44 1.33c.59.17 1.18.33 1.77.46a15.55 15.55 0 001.79.3 13.54 13.54 0 001.79.11 14.75 14.75 0 001.77-.12l.86-.15.85-.23a11.71 11.71 0 001.6-.66 5.48 5.48 0 00.74-.43 5 5 0 00.71-.5 13 13 0 001.3-1.16 13.28 13.28 0 001.11-1.37 12.49 12.49 0 00.95-1.52c.31-.51.52-1.09.79-1.63s.43-1.14.65-1.71l1.25-3.28.62 3.42a12.2 12.2 0 00.43 1.65 15.65 15.65 0 002.38 4.65 12.11 12.11 0 002.43 2.42 10.34 10.34 0 001.44.92 11 11 0 001.57.7 13.12 13.12 0 001.66.46 14.39 14.39 0 001.73.24 17 17 0 001.75 0c.59 0 1.18-.08 1.77-.13s1.18-.19 1.76-.28l1.75-.42 1.73-.52 1.71-.61 2.37-.85-1.36 2.11c-.25.37-.5.82-.73 1.25s-.44.87-.64 1.33a16.21 16.21 0 00-.93 2.78 12.16 12.16 0 00-.33 2.87 8.69 8.69 0 00.49 2.78l.27.66.34.73a8.62 8.62 0 00.83 1.15 9.73 9.73 0 001 1 11.27 11.27 0 001.17.89 13.15 13.15 0 001.26.76c.43.24.89.42 1.34.64l1.4.53 1.44.45 1 .32-.84.65a14.17 14.17 0 00-1.59 1.44 15.57 15.57 0 00-1.38 1.66c-.23.29-.41.6-.61.9a8.62 8.62 0 00-.52.94 6.23 6.23 0 00-.44 1 6.07 6.07 0 00-.33 1c-.07.35-.19.69-.23 1l-.1 1.07c0 .36 0 .72.06 1.08a4.8 4.8 0 00.18 1.06 6.25 6.25 0 00.28 1l.41 1a5.89 5.89 0 00.51 1l.56 1 .21.35h-.39a17.17 17.17 0 00-4.38.58 9.59 9.59 0 00-2.06.81 4.57 4.57 0 00-.47.29 2.36 2.36 0 00-.45.33 3.62 3.62 0 00-.42.36l-.39.41.37-.43a3 3 0 01.4-.39 3.13 3.13 0 01.44-.36c.15-.1.3-.22.46-.31a10.27 10.27 0 012.05-.94 16.38 16.38 0 014.45-.79l-.17.35-.62-1a6 6 0 01-.58-1l-.47-1a5.85 5.85 0 01-.34-1.1 4.84 4.84 0 01-.24-1.13c0-.38-.09-.77-.1-1.15v-1.17c0-.38.14-.76.2-1.14a7.17 7.17 0 01.32-1.12 6.23 6.23 0 01.43-1.08 8.28 8.28 0 01.52-1 10.85 10.85 0 01.6-1 15.58 15.58 0 011.43-1.81 15.24 15.24 0 011.69-1.61l.19 1-1.51-.43-1.49-.53c-.49-.21-1-.4-1.46-.65a12.73 12.73 0 01-1.39-.79 12.13 12.13 0 01-1.31-.95 9.68 9.68 0 01-1.14-1.14 9.18 9.18 0 01-1-1.33l-.41-.72-.33-.77a10 10 0 01-.64-3.18 13.07 13.07 0 01.29-3.25 18.15 18.15 0 01.94-3.07c.2-.5.42-1 .66-1.46s.49-.94.8-1.43l1 1.26-1.78.65-1.81.56c-.62.17-1.24.31-1.86.46s-1.25.24-1.89.31a17.72 17.72 0 01-1.93.16 18.15 18.15 0 01-2 0 16.12 16.12 0 01-1.94-.26 15.82 15.82 0 01-1.91-.51 14.71 14.71 0 01-1.82-.79 12.29 12.29 0 01-1.69-1.06 14 14 0 01-2.82-2.77 16.38 16.38 0 01-2-3.36 17.56 17.56 0 01-.71-1.82 15.07 15.07 0 01-.52-1.93l1.87.14c-.23.62-.44 1.25-.69 1.86a20 20 0 01-.86 1.81 14 14 0 01-1 1.73 16 16 0 01-1.28 1.6 13.53 13.53 0 01-1.54 1.38 6.17 6.17 0 01-.86.58 8.08 8.08 0 01-.9.52 13.43 13.43 0 01-1.93.78l-1 .25-1 .18a14 14 0 01-2 .11 15 15 0 01-2-.13 18.44 18.44 0 01-2-.35 20.9 20.9 0 01-1.92-.52 27.54 27.54 0 01-3.66-1.44c-.6-.27-1.18-.57-1.75-.88s-1.13-.64-1.72-1l1.31-1.19c.29.6.6 1.18.86 1.8a20 20 0 01.71 1.87l.3 1 .22 1a19.48 19.48 0 01.3 2 17.17 17.17 0 010 2 13.59 13.59 0 01-.24 2l-.22 1-.3 1a15.49 15.49 0 01-.78 1.88 14.32 14.32 0 01-1 1.75 19.18 19.18 0 01-1.18 1.58c-.43.52-.87 1-1.33 1.49s-.95.92-1.44 1.36a30.15 30.15 0 01-3.15 2.37q-.83.54-1.68 1c-.58.32-1.15.62-1.78.9l.07-1.19c.47.32 1 .61 1.42.94s.92.67 1.33 1.07l.64.58.59.62a15.43 15.43 0 011.08 1.34 12.47 12.47 0 01.89 1.49 11.57 11.57 0 01.68 1.58l.25.83.18.84a12.45 12.45 0 01.2 1.71 16.57 16.57 0 01-1.16 6.63 25 25 0 01-3.19 5.86l-.29-.4.67-.19c.23-.07.46-.1.69-.15.45-.1.91-.13 1.37-.19a23.15 23.15 0 012.76 0 31.89 31.89 0 015.43.76z"
                    style={{
                        transformOrigin: "147.32px 99.78px"
                    }}
                    className="animable"
                    fill="#fff"
                    opacity={0.7}
                />
            </g>
        </svg>
    )
}

export default EmptyResultsIllustration